/* ============================================================
   MealPrep.nz - review card "Read more"

   Loaded from snippets/mp-styles.liquid, AFTER mp-reviews-uniform.css.

   WHY THIS IS NOT INLINE IN THE SECTION

   The first version put this script in the section body. It never
   revealed a single button. The stylesheets are rendered at the very
   end of <body>, so an inline script in the section runs BEFORE the
   three-line clamp exists - every card measures as fitting, the
   overflow test returns false, and the script bails on all twelve.

   A document.fonts.ready fallback did not save it either: when the
   fonts are already cached that promise resolves on the next
   microtask, which is still before the stylesheet has applied.

   So the measurement has to happen after CSS. It is re-run on load,
   after webfonts settle, and on resize, because how many lines a
   review takes depends on all three.

   The click handler is bound once per card and kept separate from the
   measurement, so re-measuring can never attach a second listener -
   two listeners would toggle the class twice and the card would look
   like it was ignoring the click.
   ============================================================ */
(function () {
  var SEL = '.mp-rev';

  function evaluate(card) {
    var text = card.querySelector('.mp-rev__text');
    var btn  = card.querySelector('.mp-rev__more');
    if (!text || !btn) return;

    /* bind once, never in the measure pass */
    if (!card.dataset.mpRevBound) {
      card.dataset.mpRevBound = '1';
      btn.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : 'Read more';
      });
    }

    /* an expanded card is taller than its clamp by definition - do not
       re-hide its own toggle out from under the reader */
    if (card.classList.contains('is-open')) return;

    btn.hidden = text.scrollHeight <= text.clientHeight + 1;
  }

  function measureAll(root) {
    (root || document).querySelectorAll(SEL).forEach(evaluate);
  }

  function schedule(root) {
    requestAnimationFrame(function () { measureAll(root); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(); });
  } else {
    schedule();
  }

  window.addEventListener('load', function () { schedule(); });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { schedule(); });
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { measureAll(); }, 150);
  });

  document.addEventListener('shopify:section:load', function (e) { schedule(e.target); });
})();
